<style>
</style>
<template>
<div class="container-fluid">

    <div class="card animated fadeIn">
        <b-form @submit.prevent="updateUser()">
            <b-row>
                <b-col sm=8>
                    <b-card>
                        <div slot="header">
                            <strong>Edit User:</strong>
                        </div>
                        <div>
                            <b-form-group label="Name:" label-for="name" :label-cols-sm="2">
                                <b-form-input type="text" v-model="user.name" v-validate="'required'" id="name" name="name" :state="validateState('name')" :readonly=!readonly></b-form-input>
                                <div v-if="submitted && verrors.has('name')" class="invalid-feedback">{{ verrors.first('name') }}</div>
                            </b-form-group>
                            <b-form-group label="Email:" label-for="email" :label-cols-sm="2">
                                <b-form-input type="email" v-model="user.email" v-validate="'required|email'" id="email" name="email" :state="validateState('email')" :readonly=!readonly></b-form-input>
                                <div v-if="submitted && verrors.has('email')" class="invalid-feedback">{{ verrors.first('email') }}</div>
                            </b-form-group>
                            <!-- <b-form-group label="Account" label-for="account" :label-cols-sm="2">
                                        <multiselect v-model="watch_sel_account_opts" :options="account_opts" :multiple="false" placeholder="search ..." :show-labels="true" label="name" track-by="id">
                                        </multiselect>
                                    </b-form-group> -->
                            <b-form-group label="Account:" label-for="account" :label-cols-lg="3" v-if="account_opts.length != 0">
                                <b-form-select key="account" v-model="user.account_id" :options="account_opts" v-validate="'required'" id="account" name="account" value-field="id" text-field="name" :disabled=!readonly>
                                </b-form-select>
                            </b-form-group>
                            <!-- <b-form-group label="Role:" label-for="role" :label-cols-lg="3">
                                        <b-form-select key="role" v-model="sel_role_opts" :options="role_opts"  v-validate="'required'" id="role" name="role" >
                                        </b-form-select>
                                    </b-form-group> -->
                            <b-form-group label="Role:" label-for="role" :label-cols-sm="3">
                                <multiselect v-model="value" :options="role_opts" :multiple="true" v-validate="'required'" name="role" placeholder="search ..." :show-labels="true" label="label" track-by="id" :disabled="!this.$can('user', 'edit')">
                                </multiselect>
                            </b-form-group>
                            <b-form-group label="Password: (8-15 characters)" label-for="password" :label-cols-lg="3">
                                <b-form-input type="password" v-model="user.password" placeholder="" v-validate="'required|min:8|max:15'" id="password" name="password" ref="password" :state="validateState('password')" :readonly=!readonly></b-form-input>
                                <div v-if="submitted && verrors.has('password')" class="invalid-feedback">{{ verrors.first('password') }}</div>
                            </b-form-group>
                            <b-form-group label="Password:" label-for="password_confirmation" :label-cols-sm="2">
                                <b-form-input type="password" v-model="user.password_confirmation" v-validate="'required|confirmed:password'" placeholder="Confirm password" id="password_confirmation" name="password_confirmation" :state="validateState('password_confirmation')" :readonly=!readonly></b-form-input>
                                <div v-if="submitted && verrors.has('password_confirmation')" class="invalid-feedback">{{ verrors.first('password_confirmation') }}</div>
                            </b-form-group>
                        </div>
                    </b-card>
                </b-col>
                <b-col sm=4>
                    <b-card>
                        <div slot="header">
                            <strong>Details</strong>
                        </div>
                        Info goes here
                    </b-card>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm=8>
                    <div class="text-center">
                        <!-- TODO only activate when dirty -->
                        <button v-if="readonly" :disabled="verrors.any()" class="btn btn-primary">Save</button>
                    </div>
                </b-col>
            </b-row>
        </b-form>
    </div>
</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { vm } from '@/app.js'

export default {
    components: {
        Multiselect,
    },
    data() {
        return {
            user: {},
            submitted: false,
            // account_opts: [],
            //             account_opts: {
            //   type: Array,
            //   default: function() {
            //     return []
            //   }
            // },
            account_opts: [],

            // watch_sel_account_opts: [],
            role_opts: [],
            sel_role_opts: [],
            selectedAccounts: [],
            selectedRoles: [],
            selectedIds: [],
            value: [],

        };
    },
    // https://github.com/shentao/vue-multiselect/issues/263
    watch: {
        value(newValues) {
            this.selectedIds = newValues.map(obj => obj.id);
        }
    },
    created() {
        let uri = `/api/users/${this.$route.params.id}`;
        axios.get(uri).then((response) => {
            this.user = response.data.data.user;
            // this.account_opts = response.data.data.account_opts;
            let a = response.data.data.account_opts;
            if (!a || a.length === 0) {
                this.account_opts = [];
            } else {
                this.account_opts = a;
            }

            this.role_opts = response.data.data.role_opts;
            this.value = response.data.data.sel_role_opts;
        });

        this.$validator.extend(
            'greaterThanZero', {
                getMessage: field => field + ' needs to be > zero.',
                validate: (value) => {
                    if (value.length == 8 || (value.length >= 8 && value.length <= 15)) return true;
                    return false;
                }
            });

    },
    computed: {
        optionsArray() {
            return Object.keys(this.options).map(i => this.options[i]);
        },
        readonly() {
            //either you can edit users or you are editing your own user instance
            return this.$can('user', 'edit') || (this.$store.getters.getUserID == this.user.id)
        },
    },

    methods: {
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.verrors.has(ref)
            }
            return null
        },
        updateUser() {
            this.submitted = true;
            this.user.role_list = this.selectedIds;
            this.$validator.validate().then(valid => {
                if (valid) {
                    let uri = `/api/users/${this.user.id}`;
                    axios.patch(uri, this.user)
                        .then((response) => {
                            console.log('then');
                            if (response.data.success === true) {
                                console.log(response.data);
                                this.makeToast('info', 'User updated.');
                                location.reload();
                            } else {
                                console.log(error.response.data.message);
                                this.makeToast('danger', 'Unable to update user.');
                            }
                        })
                        .catch(function (error) {
                            console.log('catch');
                            console.log(error.response.status);
                            if (error.response && error.response.status == 422) {
                                // console.log(error.response.data.errors.email[0]);
                                vm.$setErrorsFromResponse(error.response.data);
                            } else if (error.response.status === 401) {

                                vm.$router.push({ name: '/login' });

                            }
                        });

                }
            });
        },
        makeToast(variant = null, message = null) {
            this.$bvToast.toast(message, {
                // title: `User Updated ${variant || 'default'}`,
                title: `Notification:`,
                variant: variant,
                toaster: 'b-toaster-top-center',
                solid: true
            });
            // toast.show();
        },
        prettyJSON: function (json) {
            if (json) {
                json = JSON.stringify(json, undefined, 4);
                json = json.replace(/&/g, '&').replace(/</g, '<').replace(/>/g, '>');
                return json.replace(/("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g, function (match) {
                    var cls = 'number';
                    if (/^"/.test(match)) {
                        if (/:$/.test(match)) {
                            cls = 'key';
                        } else {
                            cls = 'string';
                        }
                    } else if (/true|false/.test(match)) {
                        cls = 'boolean';
                    } else if (/null/.test(match)) {
                        cls = 'null';
                    }
                    return '<span class="' + cls + '">' + match + '</span>';
                });
            }
        }

    }

}
</script>
